import AddIcon from "@mui/icons-material/Add";
import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";
import { IResourceComponentsProps } from "@refinedev/core";
import { useParams } from "react-router-dom";

import { useGetQuiz, usePostQuiz } from "@/api/quiz.api";
import BaseQuestionsEdit from "@/components/miscellaneous/QuestionsEdit/BaseQuestionsEdit";

export const QuizEdit: React.FC<IResourceComponentsProps> = () => {
  const { cryptorId } = useParams();

  const { data } = useGetQuiz(Number(cryptorId));
  const { mutateAsync: postQuiz } = usePostQuiz();

  if (!data)
    return (
      <LoadingButton
        onClick={() => {
          postQuiz(Number(cryptorId));
        }}
      >
        <Box display="flex" gap={0.5}>
          <AddIcon />
          Create quiz
        </Box>
      </LoadingButton>
    );

  return <BaseQuestionsEdit data={data?.questions} quiz={data} />;
};
